import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { KitArticoli } from 'src/app/models/kit-articolo';
@Injectable({
  providedIn: 'root',
})
export class KitArticoliService {
  url = environment.ildatoArticoliDpi + 'api/kitarticoli';
  private http = inject(HttpClient);

  list(): Observable<KitArticoli[]> {
    return this.http.get<KitArticoli[]>(this.url + '/list');
  }

  listByIdArticolo(idArticolo: number): Observable<KitArticoli[]> {
    return this.http.get<KitArticoli[]>(
      this.url + '/listbyidarticolo/' + idArticolo,
    );
  }

  delete(idKit: number): Observable<KitArticoli> {
    return this.http.delete<KitArticoli>(this.url + '/delete/' + idKit);
  }

  update(idKit: number, kit: KitArticoli): Observable<KitArticoli> {
    return this.http.put<KitArticoli>(this.url + '/update/' + idKit, kit);
  }

  insert(kit: KitArticoli): Observable<KitArticoli> {
    return this.http.post<KitArticoli>(this.url + '/insert', kit);
  }
}
